export const SCORE_PLANES_COLORS = {
  yAxisLabel: window.getComputedStyle(document.body).getPropertyValue('--chart-y-axis-label-color').trim(),
  scoreGood: window.getComputedStyle(document.body).getPropertyValue('--ion-color-score-good').trim(),
  scoreOkay: window.getComputedStyle(document.body).getPropertyValue('--ion-color-score-okay').trim(),
  scoreBad: window.getComputedStyle(document.body).getPropertyValue('--ion-color-score-bad').trim(),
  scoreGoodTaint: window.getComputedStyle(document.body).getPropertyValue('--ion-color-score-good-taint').trim(),
  scoreOkayTaint: window.getComputedStyle(document.body).getPropertyValue('--ion-color-score-okay-taint').trim(),
  scoreBadTaint: window.getComputedStyle(document.body).getPropertyValue('--ion-color-score-bad-taint').trim(),
};
